import React, { useState, useEffect } from "react";
import { useTokens } from "../../hooks/useTokens";
import { api } from "../../api/clientInstance";
import { StatementList } from "./StatementBlock";
import "./TacticEditor.css";

/**
 * @param {{ statements: object[], onUpdate: (s: object[]) => void, tacticId?: number }} props
 */
export function TacticEditor({ statements, onUpdate, tacticId }) {
  const { tokens, loading, error } = useTokens();
  // Callable tactics for the @call picker: this user's unassigned tactics
  // (excluding THIS one — you can't call yourself). See Docs/tactic-calls.txt.
  const [callables, setCallables] = useState([]);
  useEffect(() => {
    api("/tactics/callable")
      .then((list) => setCallables(list.filter((c) => c.id !== tacticId)))
      .catch(() => setCallables([]));
  }, [tacticId]);

  if (loading) return <div className="tactic-editor-status">Loading tokens…</div>;
  if (error)   return <div className="tactic-editor-status error">Error: {error}</div>;

  const tokensWithCalls = { ...tokens, callables };

  return (
    <div className="tactic-editor">
      <StatementList statements={statements} tokens={tokensWithCalls} depth={0} onUpdate={onUpdate} />
    </div>
  );
}
